import { SearchWithExtras } from 'generated/api'
import { getMostRecentLoanSearch } from './searchHelpers'
import { isServer, Optional } from 'lib'
import { DataWrapper } from 'components/patterns/suspense/internals/types'
import { useState } from 'react'
import { createDataWrapper, createLoadingDataWrapper } from 'components/patterns/suspense/internals/DataWrapper'

const fetchRecentSearchSafely = async (): Promise<Optional<SearchWithExtras>> => {
	try {
		return await getMostRecentLoanSearch()
	} catch (e) {
		return undefined
	}
}

export const useLatestSearch = (): DataWrapper<Optional<SearchWithExtras>> => {
	const [dataWrapper] = useState<DataWrapper<Optional<SearchWithExtras>>>(() =>
		isServer() ? createLoadingDataWrapper() : createDataWrapper(fetchRecentSearchSafely)
	)

	return dataWrapper
}
